// Exportaciones principales de todos los servicios
export { roomService } from './rooms/roomService';
export { reservationService } from './reservations/reservationService';
export { authService } from './auth/authService';
export { userService } from './users/userService';
export { storageService } from './storage/storageService';
export { blockedDateService } from './blockedDates/blockedDateService';
export { holidayDateService } from './holidayDates/holidayDateService';
export { firstReservationDiscountService } from './firstReservationDiscount/firstReservationDiscountService';
export { packageService } from './packages/packageService';
export { giftCardService } from './giftCards/giftCardService';
export { couponService } from './coupons/couponService';
export { heroSlideService } from './heroSlides/heroSlideService';
export { paymentMethodService } from './paymentMethods/paymentMethodService';
export { fieldDayService } from './fieldDay/fieldDayService';
export { restaurantService } from './restaurant/restaurantService';
export { bookingConfigService } from './bookingConfig/bookingConfigService';
export { campaignService } from './campaigns/campaignService';
export { satisfactionService } from './satisfaction/satisfactionService';

// Re-export del archivo api.js original para compatibilidad
export { default as API } from './api';

// Configuración común para todos los servicios
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  TIMEOUT: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  ENDPOINTS: {
    AUTH: '/auth',
    USERS: '/users',
    ROOMS: '/room',
    RESERVATIONS: '/reservation',
  },
};

// Utility functions comunes
export const apiUtils = {
  // Formatear errores de la API
  formatError: (error) => {
    if (error.response) {
      // Error de respuesta del servidor
      return {
        status: error.response.status,
        message: error.response.data?.message || error.message,
        data: error.response.data,
      };
    } else if (error.request) {
      // Error de red
      return {
        status: 0,
        message: 'Error de conexión. Verifique su conexión a internet.',
        data: null,
      };
    } else {
      // Error de configuración
      return {
        status: -1,
        message: error.message,
        data: null,
      };
    }
  },

  // Formatear fechas para la API
  formatDate: (date) => {
    if (!date) return null;
    return date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
  },

  // Formatear fechas y horas para la API
  formatDateTime: (date) => {
    if (!date) return null;
    return date.toISOString(); // Formato ISO completo
  },

  // Obtener token de autenticación
  getAuthToken: () => {
    return localStorage.getItem('authToken');
  },

  // Verificar si el usuario está autenticado
  isAuthenticated: () => {
    return localStorage.getItem('authToken') !== null;
  },

  // Obtener headers de autenticación
  getAuthHeaders: () => {
    const token = apiUtils.getAuthToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  },
};